import React from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const Container = styled.button`
  // reset button styles
  background: transparent;
  border: unset;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;

  margin: 1rem 0;
  width: 100%;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Box = styled.div`
  display: flex;
  align-items: center;
  color: ${p => p.theme.token('text-default')};
`;
const IconContainer = styled.div`
  padding: 0.375rem;
`;

const ReadMoreButton: React.FC<{
  collapsed: boolean;
  cta: () => void;
  'aria-controls'?: string;
}> = ({ collapsed, cta, 'aria-controls': ariaControls = '' }) => {
  const { formatMessage } = useIntl();
  return (
    <Container
      data-testid="read-more"
      onClick={cta}
      aria-expanded={!collapsed}
      aria-controls={ariaControls}
    >
      {collapsed ? (
        <Box>
          {formatMessage({ id: 'readMore' })}
          <IconContainer>
            <Icon icon="select" width="16px" color="icon-default" aria-hidden />
          </IconContainer>
        </Box>
      ) : (
        <Box>
          {formatMessage({ id: 'readLess' })}
          <IconContainer>
            <Icon icon="arrowUp" width="10px" color="icon-default" aria-hidden />
          </IconContainer>
        </Box>
      )}
    </Container>
  );
};

export default ReadMoreButton;
